<template>
   <header class="header">
      <div v-if="$slots.left" class="left">
         <slot name='left'></slot>
      </div>
      <div v-if="$slots.centre" class="centre">
         <slot name='centre'></slot>
      </div>
      <div v-if="$slots.right" class="right">
         <slot name='right'></slot>
      </div>
   </header>
</template>

<script>
   export default {
   }
</script>

<style lang="scss" scoped>
@import '~/assets/SCSS/Base/00_functions.scss';
@import '~/assets/SCSS/Base/01_variables.scss';
@import '~/assets/SCSS/Base/02_mixins.scss';

@import '~/assets/SCSS/Elements/header.scss';
</style>

<style lang="scss">
   .site-logo {
      font-size: 20px;
      font-weight: 700;
      text-transform: uppercase;
      display: flex;
      color: inherit;
      align-items: center;
      text-decoration: none;

      &:hover {
         text-decoration: none;
      }

      &__image {
         padding-right: 10px;
         width: 50px;
         height: 50px;
      }

      &__name {
         text-transform: uppercase;
         margin-top: 0.75rem;
         font-family: 'Montserrat', Helvetica, sans-serif;
         font-size: 24px;
         font-weight: 700;
         letter-spacing: 2.4px;

         &:hover {
            text-decoration: none;
         }
      }
   }
</style>